import firebase from "firebase/app";
import "firebase/auth";
import { FormHandles } from "@unform/core";

import { ILoginModel } from "../../model/login";
import { writeError, writeLog } from "../../helpers/log-helper";
import { validateForm as validateLoginForm } from "./LoginForm/validator";
import { validateForm as validateRecoverForm } from "../Forgot/validator";

type SubmitCallbacks = {
  onError: (message: string) => void;
  onFinish: () => void;
};

export const submitLogin = (
  login: ILoginModel,
  formRef: React.RefObject<FormHandles>,
  { onError, onFinish }: SubmitCallbacks
) => {
  const onSuccessfulSubmit = async () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(login.email, login.password)
      .then(() => {
        // Sucesso: o redirecionamento é tratado por handleFirebaseAuth
        // (onAuthStateChanged) — mantemos o loading até a navegação ocorrer.
        writeLog("firebase auth signInWithEmailAndPassword - success");
      })
      .catch((error) => {
        onFinish();

        if (
          error.code === "auth/user-not-found" ||
          error.code === "auth/wrong-password"
        ) {
          onError("E-mail ou senha inválidos");
        } else {
          onError(error.message);
        }

        writeError(`${error.code} - ${error.message}`);
      });
  };

  const onUnsuccessfulSubmit = () => onFinish();

  validateLoginForm({
    data: login,
    formRef,
    onSuccessfulSubmit,
    onUnsuccessfulSubmit,
  });
};

export const submitRecover = (
  data: { email: string },
  formRef: React.RefObject<FormHandles>,
  { onError, onFinish, onSent }: SubmitCallbacks & { onSent: () => void }
) => {
  const onSuccessfulSubmit = async () => {
    firebase
      .auth()
      .sendPasswordResetEmail(data.email)
      .then(() => {
        onFinish();
        onSent();
      })
      .catch((error) => {
        onFinish();

        if (error.code === "auth/user-not-found") {
          onError("Usuário não encontrado.");
        } else {
          onError(error.message);
        }

        writeError(`${error.code} - ${error.message}`);
      });
  };

  const onUnsuccessfulSubmit = () => onFinish();

  validateRecoverForm({
    data,
    formRef,
    onSuccessfulSubmit,
    onUnsuccessfulSubmit,
  });
};
